import React, { useState } from "react";
import Certificate from "../../../asset/images/home/certificate.png";
import LockImage from "../../../asset/images/home/lock.png";

const DashboardSetting = () => {
    const [activeTab, setActiveTab] = useState("certificate");
    const [passwordVisibility, setPasswordVisibility] = useState({
        currentPassword: false,
        newPassword: false,
        confirmPassword: false,
    });

    const togglePassword = (field) => {
        setPasswordVisibility((prev) => ({
            ...prev,
            [field]: !prev[field],
        }));
    };

    return (
        <div className="bg-[#E2F2FF] rounded-xl p-3 lg:p-3 shadow-md border border-blue-200">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

                    {/* Left Column - Settings Options */}
                    <div className="lg:col-span-1">
                        <div className="bg-white rounded-xl shadow-md p-6">
                            <h3 className="text-2xl font-bold mb-4 text-gray-600">Settings</h3>

                            {[
                                { id: "edit-profile", label: "Edit Profile", iconPath: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" },
                                { id: "certificate", label: "Certificate", iconPath: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" },
                                { id: "change-password", label: "Change Password", iconPath: "M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" },
                            ].map((btn) => (
                                <button
                                    key={btn.id}
                                    className={`settings-button ${activeTab === btn.id ? "active" : ""}`}
                                    onClick={() => setActiveTab(btn.id)}
                                >
                                    <div className="button-content">
                                        <svg className="button-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={btn.iconPath} />
                                        </svg>
                                        <span>{btn.label}</span>
                                    </div>
                                    <svg className="button-arrow" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                                    </svg>
                                </button>
                            ))}

                            {/* Log Out Button */}
                            <div className="flex justify-center mt-20 mb-14">
                                <button className="logout-btn flex items-center gap-2">
                                    Log out
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Right Column - Tab Content */}
                    <div className="lg:col-span-2">
                        <div className="bg-white rounded-xl shadow-md p-6">

                            {/* ============================
                                EDIT PROFILE TAB
                            =============================== */}
                            {activeTab === "edit-profile" && (
                                <div className="block">
                                    <h3 className="text-2xl font-bold mb-4 text-gray-600">Edit Profile</h3>

                                    <div className="flex flex-col items-center">
                                        <img
                                            src="https://picsum.photos/seed/profile/150/150.jpg"
                                            className="w-32 h-32 rounded-full object-cover mb-4"
                                        />

                                        <button className="password-save-btn text-white py-2 px-4 rounded-full mb-6">
                                            Change Profile Photo
                                        </button>

                                        <div className="w-full">
                                            <h2 className="text-md font-bold text-left mb-4">Provide information</h2>

                                            <form className="space-y-4 w-full">
                                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                                                    {/* First Name */}
                                                    <div className="relative">
                <span className="absolute left-3 top-3 text-gray-400">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                              d="M16 7a4 4 0 11-8 0 4 4 0
                              018 0zM12 14a7 7 0 00-7 7h14a7
                              7 0 00-7-7z"/>
                    </svg>
                </span>

                                                        <input
                                                            type="text"
                                                            placeholder="First Name"
                                                            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-md
                               focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                                                        />
                                                    </div>

                                                    {/* Last Name */}
                                                    <div className="relative">
                <span className="absolute left-3 top-3 text-gray-400">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                              d="M16 7a4 4 0 11-8 0 4 4 0
                              018 0zM12 14a7 7 0 00-7 7h14a7
                              7 0 00-7-7z"/>
                    </svg>
                </span>

                                                        <input
                                                            type="text"
                                                            placeholder="Last Name"
                                                            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-md
                               focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                                                        />
                                                    </div>

                                                    {/* Email */}
                                                    <div className="relative">
                <span className="absolute left-3 top-3 text-gray-400">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                              d="M3 8l7.89 5.26a2 2 0
                              002.22 0L21 8M5 19h14a2
                              2 0 002-2V7a2 2 0
                              00-2-2H5a2 2 0
                              00-2 2v10a2 2 0
                              002 2z"/>
                    </svg>
                </span>

                                                        <input
                                                            type="email"
                                                            placeholder="Email"
                                                            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-md
                               focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                                                        />
                                                    </div>

                                                    {/* Phone Number */}
                                                    <div className="relative">
                <span className="absolute left-3 top-3 text-gray-400">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                              d="M3 5a2 2 0 012-2h3.28a1
                              1 0 01.948.684l1.498
                              4.493a1 1 0 01-.502
                              1.21l-2.257 1.13a11.042
                              11.042 0 005.516 5.516l1.13-2.257a1
                              1 0 011.21-.502l4.493
                              1.498a1 1 0 01.684.949V19a2 2 0
                              01-2 2h-1C9.716 21 3 14.284
                              3 6V5z"/>
                    </svg>
                </span>

                                                        <input
                                                            type="tel"
                                                            placeholder="Phone Number"
                                                            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-md
                               focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                                                        />
                                                    </div>
                                                </div>

                                                {/* Save Changes Button */}
                                                <div className="flex justify-center mt-6">
                                                    <button
                                                        type="button"
                                                        className="w-full password-save-btn text-white font-medium py-4 px-6 rounded-full transition-colors"
                                                    >
                                                        Save Changes
                                                    </button>
                                                </div>
                                            </form>
                                        </div>

                                    </div>
                                </div>
                            )}

                            {/* ============================
                                CERTIFICATE TAB
                            =============================== */}
                            {activeTab === "certificate" && (
                                <div className="block">
                                    <h3 className="text-2xl font-bold mb-4 text-gray-600">Certificate</h3>

                                    <div className="text-center text-gray-700">
                                        <p>Congratulations on achieving your 'Read 21: Fast Track to</p>
                                        <p>Reading' certificate!</p>

                                        <div className="flex justify-center p-4">
                                            <img src={Certificate} className="w-full max-w-md" />
                                        </div>

                                        <div className="flex justify-center">
                                            <button className="download-btn flex items-center gap-2">
                                                Download Certificate
                                                <svg className="w-4 h-4" fill="none" stroke="currentColor"
                                                     viewBox="0 0 24 24">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                          stroke-width="2"
                                                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* ============================
                                CHANGE PASSWORD TAB
                            =============================== */}
                            {activeTab === "change-password" && (
                                <div className="block px-4"> {/* Added side padding same as original */}
                                    <h3 className="text-2xl font-bold mb-4 text-gray-600">Change Password</h3>

                                    <div className="password-container">

                                        {/* Password Icon */}
                                        <div className="password-icon">
                                            <div className="flex flex-col items-center">
                                                <div className="w-36 h-36 flex items-center justify-center mb-2">
                                                    <img src={LockImage} alt="lock" />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Password Form */}
                                        <form className="w-full">

                                            <h2 className="text-md font-bold text-left mb-2">Provide information</h2>

                                            {/* CURRENT PASSWORD */}
                                            <div className="relative">
                                                <div className="password-input-group">

                                                    {/* Left Icon */}
                                                    <span className="absolute left-3 top-4 text-gray-400">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                        </svg>
                    </span>

                                                    <input
                                                        type={passwordVisibility.currentPassword ? "text" : "password"}
                                                        id="currentPassword"
                                                        placeholder="Current Password"
                                                        className="password-input pl-10 w-full"
                                                    />

                                                    {/* Toggle Icon */}
                                                    <svg
                                                        onClick={() => togglePassword("currentPassword")}
                                                        className="password-toggle cursor-pointer"
                                                        width="20"
                                                        height="20"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                                              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0
                                 8.268 2.943 9.542 7-1.274 4.057-5.064
                                 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                                                    </svg>
                                                </div>
                                            </div>

                                            {/* LINE SAME AS HTML */}
                                            <div className="border-b-2 mb-6"></div>

                                            {/* NEW PASSWORD */}
                                            <div className="relative">
                                                <div className="password-input-group">
                    <span className="absolute left-3 top-4 text-gray-400">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0
                                     00-2-2H6a2 2 0 00-2 2v6a2 2
                                     0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                        </svg>
                    </span>

                                                    <input
                                                        type={passwordVisibility.newPassword ? "text" : "password"}
                                                        id="newPassword"
                                                        placeholder="Enter New Password"
                                                        className="password-input pl-10 w-full"
                                                    />

                                                    <svg
                                                        onClick={() => togglePassword("newPassword")}
                                                        className="password-toggle cursor-pointer"
                                                        width="20"
                                                        height="20"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                                              d="M2.458 12C3.732 7.943 7.523 5
                                 12 5c4.478 0 8.268 2.943 9.542
                                 7-1.274 4.057-5.064 7-9.542
                                 7-4.477 0-8.268-2.943-9.542-7z"/>
                                                    </svg>
                                                </div>
                                            </div>

                                            {/* CONFIRM PASS */}
                                            <div className="relative">
                                                <div className="password-input-group">

                    <span className="absolute left-3 top-4 text-gray-400">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                  d="M12 15v2m-6 4h12a2 2 0
                                     002-2v-6a2 2 0
                                     00-2-2H6a2 2 0
                                     00-2 2v6a2 2
                                     0 002 2zm10-10V7a4 4 0
                                     00-8 0v4h8z"/>
                        </svg>
                    </span>

                                                    <input
                                                        type={passwordVisibility.confirmPassword ? "text" : "password"}
                                                        id="confirmPassword"
                                                        placeholder="Confirm New Password"
                                                        className="password-input pl-10 w-full"
                                                    />

                                                    <svg
                                                        onClick={() => togglePassword("confirmPassword")}
                                                        className="password-toggle cursor-pointer"
                                                        width="20"
                                                        height="20"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                                              d="M2.458 12C3.732 7.943 7.523 5
                                 12 5c4.478 0 8.268 2.943
                                 9.542 7-1.274 4.057-5.064
                                 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                                                    </svg>
                                                </div>
                                            </div>

                                            <button type="button" className="password-save-btn w-full rounded-full mt-4">
                                                Save Changes
                                            </button>
                                        </form>
                                    </div>
                                </div>

                            )}

                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default DashboardSetting;
